import React from 'react'
import { Link } from 'react-router-dom'

const AdminHeader = (props) => {
  // Destructure toggle handler and sidebar state from props
  const { onSidebarToggle, sidebarOpen } = props;

  return (
    <>
      {/* Header */}
      <div className="header">
        {/* Logo */}
        <div className="header-left">
          <a href="/" className="logo">
            <img src="/assets/img/logo.png" alt="Logo" />
          </a>
          <a href="" className="logo logo-small">
            <img src="/assets/img/logo.png" alt="Logo" width={30} height={30} />
          </a>
        </div>

        {/* Mobile Hamburger Toggle Button */}
        <button
          className="mobile-menu-toggle btn btn-info btn-sm rounded-circle position-fixed d-lg-none"
          onClick={onSidebarToggle}
          aria-label="Toggle menu"
          aria-expanded={sidebarOpen ? 'true' : 'false'}
          aria-controls="admin-sidebar"
          style={{
            top: '90px',
            left: '20px',
            width: '50px',
            height: '50px',
            fontSize: '20px',
            zIndex: 1040,
            cursor: 'pointer',
          }}
        >
          <i className="fa fa-bars" aria-hidden="true" />
        </button>

        {/* Top Nav Search */}
        <div className="top-nav-search">
          <form>
            <input type="text" className="form-control" placeholder="Search here" />
            <button className="btn" type="submit"><i className="fa fa-search" /></button>
          </form>
        </div>

        {/* Header Right Menu */}
        <ul className="nav user-menu">
          {/* Notifications */}
          <li className="nav-item dropdown noti-dropdown">
            <a href="#" className="dropdown-toggle nav-link" data-toggle="dropdown">
              <i className="fe fe-bell bell-icon" /> <span className="badge badge-pill">3</span>
            </a>
            <div className="dropdown-menu notifications">
              <div className="topnav-dropdown-header">
                <span className="notification-title">Notifications</span>
                <a href="javascript:void(0)" className="clear-noti"> Clear All </a>
              </div>
              <div className="noti-content">
                <ul className="notification-list">
                  <li className="notification-message">
                    <a href="#">
                      <div className="media">
                        <span className="avatar avatar-sm">
                          <img className="avatar-img rounded-circle" alt="User Image" src="admin-assets/img/doctors/doctor-thumb-01.jpg" />
                        </span>
                        <div className="media-body">
                          <p className="noti-details"><span className="noti-title">Dr. Ruby Perrin</span> Schedule <span className="noti-title">her appointment</span></p>
                          <p className="noti-time"><span className="notification-time">4 mins ago</span></p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="notification-message">
                    <a href="#">
                      <div className="media">
                        <span className="avatar avatar-sm">
                          <img className="avatar-img rounded-circle" alt="User Image" src="admin-assets/img/patients/patient1.jpg" />
                        </span>
                        <div className="media-body">
                          <p className="noti-details"><span className="noti-title">Charlene Reed</span> has booked her appointment to <span className="noti-title">Dr. Ruby Perrin</span></p>
                          <p className="noti-time"><span className="notification-time">6 mins ago</span></p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="notification-message">
                    <a href="#">
                      <div className="media">
                        <span className="avatar avatar-sm">
                          <img className="avatar-img rounded-circle" alt="User Image" src="admin-assets/img/patients/patient2.jpg" />
                        </span>
                        <div className="media-body">
                          <p className="noti-details"><span className="noti-title">Travis Trimble</span> sent a amount of $210 for his <span className="noti-title">appointment</span></p>
                          <p className="noti-time"><span className="notification-time">8 mins ago</span></p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="notification-message">
                    <a href="#">
                      <div className="media">
                        <span className="avatar avatar-sm">
                          <img className="avatar-img rounded-circle" alt="User Image" src="admin-assets/img/patients/patient3.jpg" />
                        </span>
                        <div className="media-body">
                          <p className="noti-details"><span className="noti-title">Carl Kelly</span> send a message <span className="noti-title"> to his doctor</span></p>
                          <p className="noti-time"><span className="notification-time">12 mins ago</span></p>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="topnav-dropdown-footer">
                <a href="#">View all Notifications</a>
              </div>
            </div>
          </li>
          {/* /Notifications */}
          {/* User Menu */}
          <li className="nav-item dropdown has-arrow">
            <a href="#" className="dropdown-toggle nav-link" data-toggle="dropdown">
              <span className="user-img"><img className="rounded-circle" src="admin-assets/img/profiles/avatar-01.jpg" width={31} alt="Ryan Taylor" /></span>
            </a>
            <div className="dropdown-menu">
              <div className="user-header">
                <div className="avatar avatar-sm">
                  <img src="admin-assets/img/profiles/avatar-01.jpg" alt="User Image" className="avatar-img rounded-circle" />
                </div>
                <div className="user-text">
                  <h6>Ryan Taylor</h6>
                  <p className="text-muted mb-0">Administrator</p>
                </div>
              </div>
              <Link className="dropdown-item" to="/profile">My Profile</Link>
              <Link className="dropdown-item" to="/settings">Settings</Link>
              <a className="dropdown-item" onClick={(e) => {
                e.preventDefault();
                localStorage.clear();
                sessionStorage.clear();
                window.location.replace('#/');
                window.history.pushState(null, '', window.location.href);
                window.onpopstate = function () {
                  window.history.go(1);
                };
              }}>Logout</a>
            </div>
          </li>
          {/* /User Menu */}
        </ul>
        {/* /Header Right Menu */}
      </div>
      {/* /Header */}
    </>
  )
}

export default AdminHeader
